import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeCommission, changeCommissionPayee } from 'bundles/apex/deals/form/store/deal/actions';
import { updateTransactionSide } from 'bundles/backoffice/vouchers/helpers/commissions';

import BrokerGrossCommissionWrapper from 'bundles/apex/deals/form/fields/broker_gross_commission/wrapper';
import ManagedInput from 'components/form/managed_input';
import Options from 'components/form/managed_input/options';

export function InternalBroker({
  changeCommission,
  changeCommissionPayee,
  commission,
  deal,
  disableCommisionView,
  invalid,
  options,
  primary,
  transactionSide,
  transactionSideOptions,
}) {
  if (primary) options = options.filter(option => option.broker);

  if (commission.broker) {
    options = [
      { disabled: commission.broker.disabled, label: commission.broker.name, value: commission.broker.id },
      ...options
    ];
  }
  options = options.sort((a, b) => a.label.localeCompare(b.label));
  const enabledUserOptions = options.filter(option => !option.disabled);
  const disabledUserOptions = options.filter(option => option.disabled);

  let userOptions;

  if (disabledUserOptions.length) {
    userOptions = <>
      <optgroup key="enabled" label="Enabled">
        <Options options={enabledUserOptions} />
      </optgroup>
      <optgroup key="disabled" label="Disabled">
        <Options options={disabledUserOptions} />
      </optgroup>
    </>;
  } else {
    userOptions = <Options options={enabledUserOptions} />;
  }

  const transactionSideOpts = transactionSideOptions && transactionSideOptions.map(([value, label]) => (
    { value: value, label: label }
  ));

  return (
    <BrokerGrossCommissionWrapper
      commission={commission}
      disabled={disableCommisionView}
      invalid={invalid}
      label={primary ? 'Primary Broker' : 'Additional Broker'}
      required={primary}
      transactionSide={transactionSide}
    >
      <ManagedInput
        aria-label={`internal-broker`}
        className="form-control"
        disabled={!!commission.id}
        includeBlank
        type="select"
        value={commission.broker && commission.broker.id}
        onValueChange={id => changeCommissionPayee(commission, { broker: findBroker(options, id) }, transactionSide)}
      >
        {userOptions}
      </ManagedInput>

      {transactionSideOpts && (
        <ManagedInput
          aria-label="transaction-side"
          className="transaction-side form-control"
          disabled={!!deal.voucher}
          includeBlank
          type="select"
          value={commission.transactionSide}
          onValueChange={(newSide) => {
            const changes = deal.hasTransactionSides
              ? updateTransactionSide(deal, commission, newSide)
              : { transactionSide: newSide };
            changeCommission(commission, changes);
          }}
        >
          <Options options={transactionSideOpts} />
        </ManagedInput>
      )
      }
    </BrokerGrossCommissionWrapper >
  );
}

InternalBroker.propTypes = {
  changeCommission: PropTypes.func.isRequired,
  changeCommissionPayee: PropTypes.func.isRequired,
  commission: PropTypes.shape({
    broker: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
    id: PropTypes.number,
    transactionSide: PropTypes.string,
  }).isRequired,
  deal: PropTypes.shape({
    hasTransactionSides: PropTypes.bool,
    voucher: PropTypes.object,
  }),
  disableCommisionView: PropTypes.bool,
  invalid: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  })),
  primary: PropTypes.bool,
  transactionSide: PropTypes.string,
  transactionSideOptions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
};

const mapDispatchToProps = {
  changeCommission,
  changeCommissionPayee,
};

const mapStateToProps = state => ({
  deal: state.deal,
  transactionSideOptions: state.options.transactionSide,
});

export default connect(mapStateToProps, mapDispatchToProps)(InternalBroker);

function findBroker(options, id) {
  const option = options.find(option => option.value === parseInt(id));
  if (option) {
    return {
      disabled: option.disabled,
      id: option.value,
      name: option.label,
    };
  }
}
